import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const PhoneEmailExistsError = () => {
    const { t } = useTranslation();

    return (
        <Alert data-testid="phone-email-exists-error" severity="error">
            {t('formErrors.phoneEmailExistsError.provideAnother')}
        </Alert>
    );
};
